var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "option-list"
  }, [_vm.title ? _c('h3', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('div', {
    staticClass: "options-grid",
    style: _vm.gridStyle
  }, _vm._l(_vm.items, function (item) {
    return _c('OptionListItem', _vm._b({
      key: item.value,
      attrs: {
        "selected": item.value === _vm.selected
      },
      on: {
        "select": _vm.selectItem
      }
    }, 'OptionListItem', item, false));
  }), 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }